import { Mixins, Component } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import ExportModel from '@/views/Project/Observation/model/export'

@Component({})
export default class ExportBtn extends Mixins<MixinInterface>() {
    showExportDialog() {
        ExportModel.showExportDialog()
    }

    get hasAccess() {
        return this.currentProject
            ? this.hasPermission(this.currentProjectPermissions, 'export_all_public_observations')
            : false
    }
}
